import { useEffect, useState } from "react";
import { getScoring } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ScoreSheet, TiebreakLine } from "@/components/game/ScoreSheet";

// Live score during play: same rows as the end screen (resilience is public information).
export default function LiveScoreDialog({ game, open, onOpenChange }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!open || !game?.id) return;
    getScoring(game.id).then(setData).catch(() => setData(null));
  }, [open, game]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="live-score-dialog"
        className="max-w-4xl max-h-[calc(90*var(--svh))] overflow-y-auto"
        style={{ background: "var(--surface)", border: "1px solid var(--line)", boxShadow: "var(--shadow-card)" }}
      >
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">Score</DialogTitle>
          <DialogDescription>After 12 rounds: population + resilience − debt. If the world reaches 3°, only resilience counts. Money is not scored.</DialogDescription>
        </DialogHeader>
        <ul className="grid gap-3 grid-cols-2" data-testid="live-score-list">
          {(data?.ranking || []).map((row) => (
            <ScoreSheet
              key={row.color}
              row={row}
              weights={data?.weights}
              player={game.players.find((p) => p.color === row.color)}
            />
          ))}
        </ul>
        <TiebreakLine ranking={data?.ranking} players={game.players} order={data?.tiebreaker_order} mode={data?.mode} />
      </DialogContent>
    </Dialog>
  );
}
